import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
            siteEndpoint: "https://gorgeous.works/api/site_tree/17",
            testEndpoint: "https://gorgeous.works/api/site_blocks/17",
            wip: false
	}
});

export default app;
